import { Text, TextProps } from "@chakra-ui/react";

export default function PatientIntakeFlowStepHeadline(props: TextProps) {
  return <Text fontSize="xl" fontWeight="bold" mb={4} {...props} />;
}
